<ng-content></ng-content>
@if (icon()) {
	<sl-icon
		class="sl-tag-icon material-symbols-outlined"
		[icon]="icon()"
		[size]="size()"
		[data-testid]="TagTestIds.TagIconElementTestId"></sl-icon>
}
@if (label()) {
	<span
		class="sl-tag-label"
		[data-testid]="TagTestIds.TagLabelElementTestId">
		{{ label() }}
	</span>
}
